import React, {Component} from 'react';
import {compose} from "redux";
import {withFirestore} from "react-redux-firebase";
import {connect} from 'react-redux'
import {useFirebase, isLoaded, isEmpty} from 'react-redux-firebase'
import {withRouter} from 'react-router-dom'
import {UserIsNotAuthenticated} from "../../utils/AuthManager";
import {CustomInput} from "../../components/Inputs";
import {BackgroundDiv} from "../../components/Containers";
import {StyledButton} from "../../components/Buttons";


class Login extends Component {
    constructor() {
        super();
        this.state = {
            email: 'co1@test.com',
            password: 'Password1234',
            validInput: true,
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.email && this.state.password){
            console.log('filled')
            if(!this.state.validInput){
                this.setState({validInput: true})
            }
        } else {
            console.log('not filled')
            if(this.state.validInput){
                this.setState({validInput: false})
            }

        }
    }

    render() {
        console.log('login rendereed')
        return (
            <div>
                <BackgroundDiv/>
                <h2>Login</h2>
                <CustomInput
                    textTransform={'none'}
                    onChange={e=>{
                        this.setState({email: e.target.value})
                    }}
                    value={this.state.email}
                />
                <CustomInput
                    type={'password'}
                    onChange={e=>{
                        this.setState({password: e.target.value})
                    }}
                    value={this.state.password}
                />

                <StyledButton
                    disabled={!this.state.validInput}
                    onClick={() => {
                        this.props.firebase.login({
                            email: this.state.email,
                            password: this.state.password
                        }).then(res => {
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    }}>
                    belépés
                </StyledButton>
                {/*<button onClick={() => {
                    this.props.firebase.createUser(
                        {
                            email: 'test8@test.com',
                            password: 'Password1234',
                        },
                        {
                            username: 'test1', email: 'test1@gmail.com', displayName: 'teeeesssg'
                        }
                    ).then(res => {
                        console.log(res)
                        this.props.firebase.updateAuth({displayName: '12312'})

                    })
                }}>create user
                </button>
                <button onClick={() => {
                    this.props.firebase.logout()
                }}>logout
                </button>*/}


            </div>
        );
    }
}

export default compose(
    withRouter,
    withFirestore,
    connect(
        // Map redux state to component props
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        })),
    UserIsNotAuthenticated,
)(Login)